import 'vuetify/styles'
import '@mdi/font/css/materialdesignicons.css'
import { createVuetify } from 'vuetify'
import * as components from 'vuetify/components'
import * as directives from 'vuetify/directives'
import * as labsComponents from 'vuetify/labs/components'
import { ko } from 'vuetify/locale'

export default createVuetify({
  components: {
    ...components,
    ...labsComponents,
  },
  directives,
  locale: {
    locale: 'ko',
    messages: { ko },
  },
})